function translateVertex(isWebgl2, vShader) {
  return isWebgl2
    ? vShader
    : vShader.replace(/ in /g, " attribute ").replace(/ out /g, " varying ");
}

export default translateVertex;
